export default __webpack_public_path__ + "static/media/image1.b6dfc9ec.png";